import React from 'react'

import { formatCurrency } from '../utils/utils'
import { SalenoteDiscount as SalenoteDiscountType } from '../interfaces/Salenote'

interface SalenoteDiscountProps {
  title: string
  discount: SalenoteDiscountType
}

const SalenoteDiscount: React.FC<SalenoteDiscountProps> = ({ title, discount }) => {
  const { originalPrice, discountedPrice, discountAmount, requiresApproval, discountApprovedAt } = discount

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
          <span>{title}</span>
          {/* Downward icon indicator */}
          <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
          {/* Tag icon indicator */}
          <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
            />
          </svg>
        </h3>
        {discountApprovedAt ? (
          <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
            Descuento aprobado
          </span>
        ) : requiresApproval ? (
          <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full">
            Requiere aprobación
          </span>
        ) : null}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="text-center">
          <div className="text-sm font-medium text-gray-600 mb-2">Precio original</div>
          <div className="text-lg font-medium text-gray-700 line-through">{formatCurrency(originalPrice)}</div>
        </div>

        <div className="text-center">
          <div className="text-sm font-medium text-gray-600 mb-2">Precio con descuento</div>
          <div className="text-lg font-bold text-green-600">{formatCurrency(discountedPrice)}</div>
        </div>

        <div className="text-center">
          <div className="text-sm font-medium text-gray-600 mb-2">Monto de descuento</div>
          <div className="text-lg font-bold text-red-600">{formatCurrency(discountAmount)}</div>
        </div>
      </div>

      {/* Visual price remaining indicator bar - inverted to show price decrease */}
      <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
        <div
          className="h-2.5 rounded-full transition-all duration-300"
          style={{
            width: `${Math.max(100 - (discountAmount / originalPrice) * 100, 0)}%`,
            background: `linear-gradient(to right, #ef4444, #f59e0b, #22c55e)`,
          }}
        ></div>
      </div>

      <div className="text-xs text-gray-600 text-center">
        Precio restante: {(100 - (discountAmount / originalPrice) * 100).toFixed(1)}% del original
      </div>
    </div>
  )
}

export default SalenoteDiscount
